import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { toast } from 'react-toastify';

import { extrairMensagemErro } from '~/Utils/Helpers';

import {
  buscarDadosGe,
  buscarSocios,
  buscarAtaExistente,
} from './ataContabilService';
import { dadosGeVazio, formatarSocioRecebido } from './helpers';

// LICOES ciclo 9 L3 — listeners isolados com flag `ativo` para evitar race-condition
// em useEffect encadeados (GE -> dados + socios; GE+data+hora -> ata existente).
const EfeitosAtaContabil = ({ onDadosGeChange }) => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (!values.codigoGe) {
      onDadosGeChange(dadosGeVazio);
      setFieldValue('socios', []);
      return undefined;
    }
    let ativo = true;
    onDadosGeChange(dadosGeVazio);
    setFieldValue('socios', []);
    Promise.all([
      buscarDadosGe(values.codigoGe),
      buscarSocios(values.codigoGe),
    ])
      .then(([dadosRes, sociosRes]) => {
        if (!ativo) return;
        onDadosGeChange({
          codigoRazao: dadosRes.codigo_razao,
          razaoSocial: dadosRes.razao_social || '',
          cnpj: dadosRes.cnpj || '',
          nire: dadosRes.nire || '',
          endereco: dadosRes.endereco || '',
          bairro: dadosRes.bairro || '',
          cidade: dadosRes.cidade || '',
          cep: dadosRes.cep || '',
          nomeContador: dadosRes.nome_contador || '',
          cpfContador: dadosRes.cpf_contador || '',
          crcContador: dadosRes.crc_contador || '',
        });
        const lista = Array.isArray(sociosRes) ? sociosRes : [];
        setFieldValue('socios', lista.map(formatarSocioRecebido));
      })
      .catch((err) => {
        if (!ativo) return;
        toast.error(extrairMensagemErro(err));
        onDadosGeChange(dadosGeVazio);
        setFieldValue('socios', []);
      });
    return () => {
      ativo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.codigoGe]);

  useEffect(() => {
    if (!values.codigoGe || !values.dataReuniao || !values.horaReuniao) {
      return undefined;
    }
    const dataOk = /^\d{2}\/\d{2}\/\d{4}$/.test(values.dataReuniao);
    const horaOk = /^\d{2}:\d{2}$/.test(values.horaReuniao);
    if (!dataOk || !horaOk) return undefined;

    const dataHoraReuniao = `${values.dataReuniao} ${values.horaReuniao}`;
    let ativo = true;
    buscarAtaExistente(values.codigoGe, dataHoraReuniao)
      .then((res) => {
        // Backend retorna null quando a ata nao existe; nova ata segue sem aviso.
        if (!ativo || !res || !res.exercicio) return;
        setFieldValue('exercicio', res.exercicio);
        setFieldValue('realizadaDeForma', res.realizada_de_forma);
        setFieldValue('parceria', res.parceria);
        setFieldValue('lucro', Number(res.lucro || 0));
        setFieldValue('secretario', res.secretario || '');
        if (Array.isArray(res.socios) && res.socios.length > 0) {
          setFieldValue('socios', res.socios.map(formatarSocioRecebido));
        }
        toast.info('Ata existente carregada para re-impressão.');
      })
      .catch((err) => {
        if (!ativo) return;
        toast.error(extrairMensagemErro(err));
      });
    return () => {
      ativo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.codigoGe, values.dataReuniao, values.horaReuniao]);

  return null;
};

export default EfeitosAtaContabil;
